import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getMyActionsByTime } from '../../actions/action';
import ActionBar from '../SideBars/Action';
import { Button, makeStyles } from '@material-ui/core';
import moment from 'moment';

const ActionStreams = ({ getMyActionsByTime, contact: { actions } }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      marginTop: '1em'
    },
    actionButton: {
      display: 'block',
      marginBottom: '5px',
      textTransform: 'capitalize',
      background: '#EEEEEE'
    },
    link: {
      color: 'black',
      display: 'flex'
    },
    actionDiv: {
      width: '70%'
    },
    nameDiv: {
      width: '20%',
      display: 'flex'
    },
    fullName: {
      color: '#7F7F7F'
    },
    actionName: {
      paddingLeft: '1%',
      textAlign: 'left'
    },
    actionTime: { paddingLeft: '8%', textAlign: 'right', color: 'red' },
    orgName: {
      paddingRight: '1%'
    }
  }));

  const classes = useStyles();

  useEffect(() => {
    getMyActionsByTime();
  }, [getMyActionsByTime]);
  return (
    <div className={classes.root}>
      <div>
        <ActionBar />
      </div>
      <div className={classes.actionDiv}>
        <Fragment>
          {actions && actions.length > 0 ? (
            <Fragment>
              <Fragment>
                {actions.map(action => (
                  <Button
                    key={action._id}
                    className={classes.actionButton}
                    variant='outlined'
                    fullWidth
                  >
                    <Link
                      to={`/show_contact/${action.contact}`}
                      className={classes.link}
                    >
                      <div className={classes.nameDiv}>
                        <div className={classes.orgName}>
                          <h4>{action.organization}</h4>
                        </div>
                        <div className={classes.fullName}>
                          <small>{`${action.firstName} ${action.lastName}`}</small>
                        </div>
                      </div>

                      <div className={classes.actionTime}>
                        {moment(action.time).format('ll')}
                      </div>
                      <div className={classes.actionName}>{action.name}</div>
                    </Link>
                  </Button>
                ))}
              </Fragment>
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
        </Fragment>
      </div>
    </div>
  );
};

ActionStreams.propTypes = {
  getMyActionsByTime: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, { getMyActionsByTime })(ActionStreams);



// WEBPACK FOOTER //
// ./src/components/actionStream/ActionStreams.js